import CssLayers from "../CssLayers";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";

export default function MentionsPortal({ top, left, css, children }) {
  return ReactDOM.createPortal(
    <div
      css={{
        position: "absolute",
        zIndex: CssLayers.MENTIONS,
        ...css,
      }}
      style={{
        top,
        left,
      }}
    >
      {children}
    </div>,
    document.body,
  );
}

MentionsPortal.propTypes = {
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  css: PropTypes.object,
  children: PropTypes.any.isRequired,
};
